const addCliplisterScript = (isConsentAllowed: boolean, scriptUrl: string) => {
  if (isConsentAllowed) {
    const script = document.createElement('script');
    script.setAttribute('src', scriptUrl);
    script.setAttribute('id', 'cliplister-script');
    document.head.insertBefore(script, document.head.firstElementChild);
  }
};

export default addCliplisterScript;
